var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "base-dialog",
    {
      attrs: { name: _vm.name, scrollable: false, width: "600px" },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [_vm._v("Select Cap")]
          },
          proxy: true,
        },
        {
          key: "dialogFooter",
          fn: function () {
            return [
              _c(
                "v-btn",
                {
                  staticClass: "mr-3",
                  attrs: { color: "grey", outlined: "" },
                  on: { click: _vm.closeDialog },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", disabled: !_vm.selectedCapId },
                  on: { click: _vm.confirmSelection },
                },
                [_vm._v("Confirm")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "v-container",
        [
          _c(
            "v-row",
            [
              _c("v-col", { attrs: { cols: "12" } }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-space-between align-center mb-3",
                  },
                  [
                    _c("h4", [_vm._v(_vm._s(_vm.dialogTitle))]),
                    _c(
                      "v-btn",
                      {
                        staticClass: "ml-2",
                        attrs: {
                          color: "primary",
                          small: "",
                          disabled: !_vm.locationId,
                        },
                        on: { click: _vm.addSingleCap },
                      },
                      [
                        _c("v-icon", { attrs: { left: "", small: "" } }, [
                          _vm._v("mdi-plus"),
                        ]),
                        _vm._v(" Add New Cap "),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("p", { staticClass: "text-subtitle-2 grey--text" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.capType === "in"
                          ? "Select an Input Cap to connect to this cable"
                          : "Select an Output Cap to connect to this cable"
                      ) +
                      " "
                  ),
                ]),
              ]),
            ],
            1
          ),
          _vm.availableCaps && _vm.availableCaps.length > 0
            ? _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-list",
                        { attrs: { dense: "" } },
                        _vm._l(_vm.availableCaps, function (cap) {
                          return _c(
                            "v-list-item",
                            {
                              key: cap.id,
                              class: {
                                "v-list-item--active":
                                  _vm.selectedCapId === cap.id,
                              },
                              attrs: { "two-line": "" },
                              on: {
                                click: function ($event) {
                                  return _vm.selectCap(cap)
                                },
                              },
                            },
                            [
                              _c(
                                "v-list-item-avatar",
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "primary" } },
                                    [_vm._v("mdi-cable-data")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(_vm._s(cap.title)),
                                  ]),
                                  _c("v-list-item-subtitle", [
                                    _vm._v(
                                      " Direction: " +
                                        _vm._s(
                                          cap.capDirection === "IN"
                                            ? "Input"
                                            : "Output"
                                        ) +
                                        " • Order: " +
                                        _vm._s(cap.sortOrder || 0) +
                                        " • Active: " +
                                        _vm._s(cap.isActive ? "Yes" : "No") +
                                        " "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c("v-list-item-action", [
                                _c(
                                  "div",
                                  { staticClass: "d-flex align-center" },
                                  [
                                    _vm.selectedCapId === cap.id
                                      ? _c(
                                          "v-icon",
                                          {
                                            staticClass: "mr-2",
                                            attrs: { color: "primary" },
                                          },
                                          [_vm._v("mdi-check-circle")]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          icon: "",
                                          small: "",
                                          color: "error",
                                          loading: _vm.isDeletingCap,
                                          disabled: _vm.isDeletingCap,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.deleteCap(cap)
                                          },
                                        },
                                      },
                                      [
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("mdi-delete"),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-alert", { attrs: { type: "info", outlined: "" } }, [
                        _vm._v(
                          " No " +
                            _vm._s(_vm.capType === "in" ? "input" : "output") +
                            " caps available for selection. "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }